import { IconButton, makeStyles, TableCell, TableRow } from '@material-ui/core';
import { Add as AddIcon, BrokenImage as BrokenImageIcon } from '@material-ui/icons';

import { BASKET_IMAGE_PATH } from '../../../baskets/constants/baskets-app-paths.constants';
import { Basket } from '../../../baskets/types/basket.type';

const useStyles = makeStyles((theme) => ({
  photo: { width: 40, height: 40, objectFit: 'cover' as const, borderRadius: 4 },
  photoFallback: { width: 40, height: 40, color: theme.palette.grey[400] },
}));

type Props = { basket: Basket; onAdd: (basket: Basket) => void };

export function CatalogBasketRow({ basket, onAdd }: Props) {
  const classes = useStyles();
  return (
    <TableRow hover>
      <TableCell style={{ width: 56 }}>
        {basket.photo ? (
          <img src={BASKET_IMAGE_PATH(basket.photo)} alt="" className={classes.photo} />
        ) : (
          <BrokenImageIcon className={classes.photoFallback} />
        )}
      </TableCell>
      <TableCell>{basket.name}</TableCell>
      <TableCell>{basket.reference}</TableCell>
      <TableCell>{basket.subCategory?.name ?? '—'}</TableCell>
      <TableCell align="right">{basket.price.toFixed(2)} €</TableCell>
      <TableCell align="right" style={{ width: 56 }}>
        <IconButton size="small" aria-label={`Ajouter ${basket.name}`} onClick={() => onAdd(basket)}>
          <AddIcon fontSize="small" />
        </IconButton>
      </TableCell>
    </TableRow>
  );
}
